import { initializeMetrica } from 'utils/metrica';
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import * as Sentry from "@sentry/browser";
import App from './App'
import reportWebVitals from './reportWebVitals'
import 'config/i18'
import 'mapbox-gl/dist/mapbox-gl.css'
import './index.scss'

initializeMetrica();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)

Sentry.init({ dsn: "https://23621090540b4d25abf7bb4d5923fed5@glitchtip.dita.systems/2", debug: true });

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

